<template>
	<create-employee-editor />
</template>

<script>
	import CreateEmployeeEditor from '@/components/employee/CreateEmployeeEditor';

	export default {
		name: 'PageEmployeeCreate',
		components: {
			CreateEmployeeEditor
		},
		created() {
			this.$store.dispatch('setPageTitle', `Create New ${this.$term('employee', { case: 'title' })}`);
		}
	};
</script>

<style></style>
